@if (cardDetail()) {
  <app-view-cards
    [cardDetail]="cardDetail()"
    [cardBalance]="cardBalance()"
    title="Card details">
    <ng-container heading>
      @if (cardDetail().holder; as holder) {
        <div class="col-auto">
          <app-avatar
            [firstName]="holder.first_name"
            [lastName]="holder.last_name"
            [size]="'lg'"></app-avatar>
        </div>
        <div class="col">
          <p class="text-muted mb-1">Cardholder:</p>
          <div class="h3">{{ holder.first_name }} {{ holder.last_name }}</div>
        </div>
      }
    </ng-container>
  </app-view-cards>
} @else {
  <app-loader class="my-4"></app-loader>
}
